export enum BuyerBewareCard {
  UNAUTHORIZED_ACTIVITIES = "unauthorized_activities",
  MISLEADING_CLAIMS = "misleading_claims",
}

type BuyerBewareCardConfig = {
  title: string
  deceptionTypes: readonly string[]
  checklistItems: readonly string[]
}

export const dataByBuyerBewareCard: Record<
  BuyerBewareCard,
  BuyerBewareCardConfig
> = {
  [BuyerBewareCard.UNAUTHORIZED_ACTIVITIES]: {
    title: "Unauthorized Activities",
    deceptionTypes: ["unauthorized_action", "falsified_records"],
    checklistItems: [
      "Unauthorized charges",
      "Undisclosed loans",
      "Identity theft",
      "Forged signatures",
      "Fake contracts",
      "Falsified permits",
    ],
  },
  [BuyerBewareCard.MISLEADING_CLAIMS]: {
    title: "Misleading Claims",
    deceptionTypes: ["misrepresentation"],
    checklistItems: [
      "Bait & switch",
      "Overstated savings",
      "Hidden fees",
      "Misrepresented specs",
      "False performance",
      "Misleading warranty",
    ],
  },
}

export const BUYER_BEWARE_CARDS = Object.values(BuyerBewareCard)
